import ChangePasswordForm from '@/components/ChangePassword/ChangePasswordForm';
import {
  useResponsiveFontSize,
  useResponsiveHeight,
  useResponsiveWidth,
} from '@/components/Util/reactResponsiveDimensions';
import colors from '@/config/colors';
import { Image, StyleSheet, View } from 'react-native';
import { Text } from '@/components/Text';
import { isPatientApp } from '@/config/constants';
import TherapistPasswordChangeForm from 'src/components/ChangePassword/TherapistPasswordChangeForm';

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: isPatientApp
      ? colors.white
      : colors.newUI.therapist.bgBlue10,
  },
  infoTextStyle: {
    alignSelf: 'center',
    color: colors.darkGrey,
  },
});

function PasswordChangeScreen(props) {
  const responsiveFontSizeValue1 = useResponsiveFontSize(1);
  const responsiveStyles = StyleSheet.create({
    logoWrapper: {
      width: useResponsiveWidth(40),
      height: useResponsiveHeight(10),
      marginTop: responsiveFontSizeValue1,
      alignSelf: 'center',
    },
    backButton: {
      position: 'absolute',
      left: useResponsiveWidth(1),
      top: useResponsiveHeight(1),
    },
    logoStyle: {
      resizeMode: 'contain',
      width: '100%',
      height: '100%',
    },
  });

  const renderPatientHeader = () => (
    <>
      <View style={responsiveStyles.logoWrapper}>
        <Image
          source={require('../assets/neolexon_Logo_ohneClaim.png')}
          style={responsiveStyles.logoStyle}
        />
      </View>
      <View className="my-5">
        <Text className="text-center text-xl text-gray-600">
          Passwort ändern
        </Text>
      </View>
    </>
  );

  return (
    <View style={styles.container}>
      {isPatientApp ? renderPatientHeader() : null}
      {isPatientApp ? <ChangePasswordForm /> : <TherapistPasswordChangeForm />}
    </View>
  );
}

export default PasswordChangeScreen;
